import { render } from "./routeberanda.vue?vue&type=template&id=3d79839a"
import script from "./routeberanda.vue?vue&type=script&lang=js"
export * from "./routeberanda.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__